export default __webpack_public_path__ + "static/media/ArrowRight.880c3895.svg";